import React, { useReducer } from 'react';
import axios from 'axios';
import MenuContext from './menuContext';
import menuReducer from './menuReducer';

const MenuState = props => {
    const initialState = {
        menus: [],
        current: null,
        loading: true,
        error: null
    };

    const [state, dispatch] = useReducer(menuReducer, initialState);

    // Get Menus by Store ID
    const getMenus = async storeId => {
        try {
            const res = await axios.get(`/api/menus/store/${storeId}`);

            dispatch({
                type: 'GET_MENUS',
                payload: res.data
            });
        } catch (err) {
            dispatch({
                type: 'MENU_ERROR',
                payload: err.response?.data?.msg || err.message
            });
        }
    };

    // Add Menu
    const addMenu = async menu => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.post('/api/menus', menu, config);

            dispatch({
                type: 'ADD_MENU',
                payload: res.data
            });
            return res.data;
        } catch (err) {
            const errorMsg = err.response?.data?.msg || err.message;
            dispatch({
                type: 'MENU_ERROR',
                payload: errorMsg
            });
            throw err;
        }
    };

    // Delete Menu
    const deleteMenu = async id => {
        try {
            await axios.delete(`/api/menus/${id}`);

            dispatch({
                type: 'DELETE_MENU',
                payload: id
            });
        } catch (err) {
            dispatch({
                type: 'MENU_ERROR',
                payload: err.response?.data?.msg || err.message
            });
        }
    };

    // Update Menu
    const updateMenu = async menu => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.put(`/api/menus/${menu.menu_id}`, menu, config);

            dispatch({
                type: 'UPDATE_MENU',
                payload: res.data
            });
            return res.data;
        } catch (err) {
            const errorMsg = err.response?.data?.msg || err.message;
            dispatch({
                type: 'MENU_ERROR',
                payload: errorMsg
            });
            throw err;
        }
    };

    // Reorder Menus
    const reorderMenus = async (orderedIds) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            await axios.post('/api/menus/reorder', { ordered_ids: orderedIds }, config);
            // Sıralama değiştiği için menüleri tekrar çekmek en güvenlisi, 
            // ama performans için local state'i de güncelleyebiliriz.
            // Şimdilik sadece başarılı dönelim, çağıran yer listeyi yenilesin.
            return true;
        } catch (err) {
            const errorMsg = err.response?.data?.msg || err.message;
            dispatch({
                type: 'MENU_ERROR',
                payload: errorMsg
            });
            throw err;
        }
    };

    // Set Current Menu
    const setCurrentMenu = menu => {
        dispatch({ type: 'SET_CURRENT_MENU', payload: menu });
    };

    // Clear Current Menu
    const clearCurrentMenu = () => {
        dispatch({ type: 'CLEAR_CURRENT_MENU' });
    };

    return (
        <MenuContext.Provider
            value={{
                menus: state.menus,
                current: state.current,
                loading: state.loading,
                error: state.error,
                getMenus,
                addMenu,
                updateMenu,
                reorderMenus,
                deleteMenu,
                setCurrentMenu,
                clearCurrentMenu
            }}
        >
            {props.children}
        </MenuContext.Provider>
    );
};

export default MenuState;
